module.exports = __webpack_public_path__ + "static/media/cents2.08dcb581.webp";